import { Node } from "reactflow";
import { tutorial_baseline, example, future_of_work, global_warming } from "../../user-study/script";
import { TaskValue } from "../../user-study/task-by-group";


export const initialBaselineNodes = (task: TaskValue): Node[] => {

  if (task === TaskValue.Tutorial) { // interface tutorial
    return [
      {
        id: '1',
        type: 'memo',
        data: {
          placeholder: '',
          state: {
            title: 'Tutorial instruction',
            memo: tutorial_baseline,
            isEditing: false,
          }
        },
        dragHandle: '.drag-handle',
        position: { x: 0, y: 0 },
      },
    ];
  }

  return [
    {
      id: '1',
      type: 'memo',
      data: {
        placeholder: '',
        state: {
          title: 'Task instruction',
          memo: task === TaskValue.AIFutureWork ? future_of_work : global_warming,
          isEditing: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 0, y: 0 },
    },
  ];
}